import { MAX_WELCOME_DISPLAYS, COUNTER_WELCOME_DISPLAYS } from '@ezugi/constants';
import { ls } from '@ezugi/utils';

import { maxTutorialDisplaysSelector } from '../store/selectors';
import { RootState } from '../store/types';

type TWelcomeDialog = { noWelcomeDialogKey: string, gameId: number, state: RootState };

/**
 * returns `true` if the welcome dialog/tutorial popup should be displayed
 * taking into account 1) if user checked 'don't show this popup again'
 * and 2) if the threshold for max displayed configured in BO was already reached
 */
export const isWelcomeDialogAvailable = ({ noWelcomeDialogKey, gameId, state }: TWelcomeDialog) => {
  const [ , noWelcomeDialog ] = ls.get(noWelcomeDialogKey);
  let [ , maxNrDisplays ] = ls.get(MAX_WELCOME_DISPLAYS);
  let [ , counterNrDisplays ] = ls.get(COUNTER_WELCOME_DISPLAYS);

  let isAvailable = true;

  if (noWelcomeDialog) {
    isAvailable = false;
  } else {
    const maxNrDisplaysExists = maxNrDisplays?.hasOwnProperty(gameId);
    const counterNrDisplaysExists = counterNrDisplays?.hasOwnProperty(gameId);

    const maxDisplays = maxTutorialDisplaysSelector(state);
    if (maxDisplays !== '' && !isNaN(Number(maxDisplays))) {
      // in BO there is a max limit configured for how many times welcome popup should be displayed

      // add or update max limit in local storage
      if (!maxNrDisplaysExists || maxNrDisplays[gameId] !== Number(maxDisplays)) {
        maxNrDisplays = {
          ...maxNrDisplays,
          [gameId]: Number(maxDisplays),
        };
        ls.put(MAX_WELCOME_DISPLAYS, maxNrDisplays);
      }

      // initialize counter in local storage
      if (!counterNrDisplaysExists) {
        counterNrDisplays = {
          ...counterNrDisplays,
          [gameId]: 0,
        };
        ls.put(COUNTER_WELCOME_DISPLAYS, counterNrDisplays);
      }

      if (counterNrDisplays[gameId] >= maxNrDisplays[gameId]) {
        isAvailable = false;
      }
    } else {
      // in BO there's no max limit configured for how many times welcome popup should be displayed
      // remove from local storage old configs

      if (maxNrDisplaysExists) {
        delete maxNrDisplays[gameId];
        ls.put(MAX_WELCOME_DISPLAYS, maxNrDisplays);
      }

      if (counterNrDisplaysExists) {
        delete counterNrDisplays[gameId];
        ls.put(COUNTER_WELCOME_DISPLAYS, counterNrDisplays);
      }
    }
  }

  if (isAvailable && counterNrDisplays?.hasOwnProperty(gameId)) {
    counterNrDisplays[gameId]++;
    ls.put(COUNTER_WELCOME_DISPLAYS, counterNrDisplays);
  }

  return isAvailable;
};
